export const EMPTY_FIELD = 'EMPTY_FIELD';
export const INVALID_EMAIL = 'INVALID_EMAIL';
export const INVALID_PASSWORD = 'INVALID_PASSWORD';
